module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp12_8017.9da17f70.png";